import { RouteObject } from 'react-router-dom';
import { loadable } from '@sib/ui';
import { paths } from '@spendbrain/config/paths';

export const routes: RouteObject[] = [
  {
    path: paths.teamMembers.root,
    element: loadable(() => import('./pages/TeamMembersPage')),
  },
  {
    path: paths.teamMembers.tab,
    element: loadable(() => import('./pages/TeamMembersPage')),
  },
];
